exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#import-schema-panel{padding:40px;margin:0 20px;background-color:#f5f5f5}#import-schema-panel .result-item{padding:5px}\n", ""]);

